var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "welcome-fade" } }, [
    _vm.visible
      ? _c("div", { staticClass: "welcome-transition-overlay" }, [
          _c("div", { staticClass: "welcome-content" }, [
            _c("div", { staticClass: "logo-container" }, [
              _c("img", {
                staticClass: "welcome-logo",
                attrs: {
                  src: "https://static.supsis.live/common/supsisAiLogo.png",
                  alt: _vm.$t("message.supsisAiLogoAlt"),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "messages-container" }, [
              _c("h1", { staticClass: "welcome-title" }, [
                _c("span", { staticClass: "typing-text" }, [
                  _vm._v(_vm._s(_vm.displayedTitle)),
                ]),
                _vm.isTypingTitle
                  ? _c("span", { staticClass: "cursor" }, [_vm._v("|")])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "welcome-message" }, [
                _c("span", { staticClass: "typing-text colored-text" }, [
                  _vm._v(_vm._s(_vm.displayedMessage)),
                ]),
                _vm.isTypingMessage
                  ? _c("span", { staticClass: "cursor" }, [_vm._v("|")])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }